import axios from "axios";
import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Input,
    InputGroup,
    ListGroup,
    ListGroupItem,
    Modal,
    ModalBody,
    ModalHeader,
    Pagination,
    PaginationItem,
    PaginationLink,
    Row,
    Spinner,
    Table,
    Badge,
    UncontrolledDropdown,
    Label,
} from "reactstrap";
import * as loadingData from "../loadingSetdataTool.json";
import FadeIn from "react-fade-in/lib/FadeIn";
import { FetchAxiosGet } from "../../../../api/axios";
import { GetCookieData, GetCookieToken } from "../../../Cookie/GetCookie";
import LoadingData from "../../../TESTPage/LoadingData";

const Menu2 = (props) => {
    const { userID } = props
    const user = GetCookieData("userData");
    const filterSubAdmin = user?.positionSubAdmin?.map(i => i.type_sub_admin);
    const [data, setData] = useState([]);
    const [dataGroup, setDataGroup] = useState(null);
    const [dataClassName, setDataClassName] = useState(null);
    const [dataType, setDataType] = useState(null);
    const [dataDetail, setDataDetail] = useState(null);
    const [dataLifetime, setDataLifetime] = useState(null);
    const [loading, setLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const token = GetCookieToken("userToken");
    const [dataInfo, setDataInfo] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [pushkeyword, setPushKeyword] = useState("");
    const [keyword, setKeyword] = useState("");
    const [typeData, setTypeData] = useState([]);
    const [filterTypeName, setFilterTypeName] = useState(null)

    const letEffect = async (filterd = null) => {
        setLoading(true)
        let groupArray = []
        let params = new URLSearchParams({
            page: currentPage,
            size: 10,
            "order[0]": "item_id",
            "order[1]": "ASC",
            // "filter[item_condition][0]": "สภาพสมบูรณ์",
            // "filter[item_status][0]": "อนุมัติ",
            // "filter[class_name][0]": "คอมพิวเตอร์",
            search: pushkeyword
        });
        if (filterd !== null) {
            if (filterd === "ทั้งหมด") {
                params.delete("filter[type_name][0]", filterd)
            } else {
                params.append("filter[type_name][0]", filterd)
            }
        }
        const fetchEquipment = await FetchAxiosGet("/api/equipment/datatable", token, params)
        setData(fetchEquipment.result)
        fetchEquipment.result?.map(i => {
            groupArray.push(Number(i.item_id))
        })
        letEquipmentName(groupArray)
        setDataInfo(() => fetchEquipment.info);
        setTotalPages(Math.ceil(fetchEquipment.info.totalRows / fetchEquipment.info.pageSize));
        setTimeout(() => {
            setLoading(false);
        }, 1500);
    }

    useEffect(() => {
        letEffect(filterTypeName)
        getTypeData()
    }, [currentPage, pushkeyword, filterTypeName])

    const handleSearch = () => {
        setPushKeyword(() => keyword);
    }
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSearch()
        }
    };

    const toggleModal = async (group, className, type, detail, lifetime) => {
        setOpenModal(!openModal)
        setDataGroup(group)
        setDataClassName(className)
        setDataType(type)
        setDataDetail(detail)
        setDataLifetime(lifetime)
    }

    const [allEquipment, setAllEquipment] = useState([])
    const letEquipmentName = async (id) => {
        let params = new URLSearchParams({
            page: currentPage,
            size: 10,
            "order[0]": "created_date",
            "order[1]": "DESC",
        });
        if (filterSubAdmin.length === 0 || (Number(filterSubAdmin) !== 0 && Number(filterSubAdmin) !== 4)) {
            params.append("filter[users_id_borrow][0]", userID)
        }
        id.forEach((element, idx) => {
            params.append(`filter[equipment_id][${idx}]`, element)
        });
        const fetchEquipment = await FetchAxiosGet("/api/borrow/equipment/datatable", token, params)
        setAllEquipment(fetchEquipment.result)
    }

    const checkingStatus = (host) => {
        return (
            <Badge pill color={host ? host.status === 0 ? "primary" : host.status === 1 ? "success" : "secondary" : "secondary"}>
                {host ? host.status === 0 ? "จอง" : host.status === 1 ? "จ่าย" : "ว่าง" : "ว่าง"}
            </Badge>
        )
    }


    const allTypeOptions = [{ type_name: "ทั้งหมด", type_name_count: null }, ...typeData];
    const getTypeData = async () => {
        const getData = await FetchAxiosGet("/api/equipment/type", token)
        setTypeData(getData?.result);
    };

    return (
        <div>
            <FadeIn>
                {/* <Card style={{ minHeight: "730px" }}>
            <CardBody> */}
                {/* <CardTitle>ข้อมูลครุภัณฑ์</CardTitle> */}
                <Row className="mt-3">
                    <Col xs={12} md={6} lg={6} xxl={4}>
                        <Label className="text-end ps-0">
                            ครุภัณฑ์
                        </Label>
                        <InputGroup>
                            <Input
                                type="search"
                                value={keyword}
                                style={{ width: "40%" }}
                                placeholder="...กรุณาใส่คำที่ต้องการค้นหา"
                                onKeyDown={handleKeyDown}
                                onChange={(e) => setKeyword(e.target.value)}
                            />
                            <Button
                                style={{ display: "flex", alignItems: "center" }}
                                color="primary"
                                onClick={handleSearch}
                            >
                                <i className="fa-sharp fa-solid fa-magnifying-glass fa-xl"></i>
                            </Button>
                        </InputGroup>
                    </Col>
                    <Col xs={12} md={6} lg={6} xxl={3}>
                        <Label className="text-end ps-0">
                            ประเภทครุภัณฑ์
                        </Label>
                        <Col className="px-0">
                            <Input
                                type="select"
                                // value={searchData.equipmentId}
                                onChange={(e) => {
                                    setFilterTypeName(e.target.value);
                                    setCurrentPage(1)
                                }}
                            >
                                {allTypeOptions.map((type, index) => (
                                    <option key={index} value={index === 0 ? null : type.type_name}>
                                        {type.type_name}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    </Col>
                </Row>
                <br />
                <Row className="mt-1">
                    <Col xs={12} md={12} lg={12} xxl={12}>
                        <Table striped hover responsive style={{ verticalAlign: "middle", overflowX: "scroll", whiteSpace: "nowrap" }}>
                            <thead className="table-dark">
                                <tr>
                                    {/* <th className="text-center">เลขครุภัณฑ์</th> */}
                                    <th className="text-center">ลำดับ</th>
                                    <th>ชื่อครุภัณฑ์</th>
                                    <th>รายละเอียด</th>
                                    <th>ปีงบประมาณ</th>
                                    <th>หน่วยงานที่รับผิดชอบ</th>
                                    <th>เลขครุภัณฑ์</th>
                                    {/* <th>ผู้ใช้งานปัจจุบัน</th> */}
                                    <th>สภาพการใช้งาน</th>
                                    <th>สถานะการใช้งาน</th>
                                    <th></th>
                                </tr>
                            </thead>
                            {loading ?
                                <tbody>
                                    <tr>
                                        <td colSpan={10}>
                                            <LoadingData />
                                        </td>
                                    </tr>
                                </tbody>
                                :
                                <tbody className="table-light">
                                    {data.length > 0 ? data.map((item, idx) => {
                                        let checkStatus = allEquipment.find(y => Number(y.equipment_id) === Number(item.item_id))
                                        let cp = (currentPage - 1) * 10;
                                        return (
                                            <tr key={idx}>
                                                <td className="text-center">{idx + cp + 1}</td>
                                                <td>{item.mdata_name}</td>
                                                <td>{item.detail}</td>
                                                <td>{item.fiscal_year}</td>
                                                <td>{item.chvdeslngtha}</td>
                                                <td>{item.item_format}</td>
                                                <td>{item.item_condition}</td>
                                                <td className="text-center font-size-16">{checkingStatus(checkStatus)}</td>
                                                <td>
                                                    <UncontrolledDropdown className="dropdown">
                                                        <DropdownToggle
                                                            className="text-muted font-size-16"
                                                            tag="a"
                                                            color="white"
                                                        >
                                                            <i className="mdi mdi-dots-horizontal"></i>
                                                        </DropdownToggle>
                                                        <DropdownMenu className="dropdown-menu-end">
                                                            <DropdownItem onClick={() => toggleModal(item.group_name, item.class_name, item.type_name, item.detail, item.lifetime)}>
                                                                รายละเอียดครุภัณฑ์
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                </td>
                                            </tr>
                                        );
                                    })
                                        : <tr>
                                            <td colSpan="8" className="text-center fs-5">
                                                ไม่มีข้อมูล
                                            </td>
                                        </tr>}
                                </tbody>}
                        </Table>
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-content-end">
                        <Pagination
                            className="mt-3"
                            aria-label="Page navigation example"
                        >
                            <PaginationItem disabled={currentPage === 1}>
                                <PaginationLink onClick={() => setCurrentPage(1)}>
                                    หน้าแรก
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem disabled={currentPage === 1}>
                                <PaginationLink
                                    onClick={() => setCurrentPage(currentPage - 1)}
                                >
                                    ย้อนกลับ
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem active>
                                <PaginationLink>หน้า {currentPage} จาก {dataInfo.totalPage}</PaginationLink>
                            </PaginationItem>
                            <PaginationItem
                                disabled={
                                    currentPage === dataInfo.totalPage ||
                                    totalPages === 0
                                }
                            >
                                <PaginationLink
                                    onClick={() =>
                                        setCurrentPage(dataInfo.currentPage + 1)
                                    }
                                >
                                    ถัดไป
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem
                                disabled={
                                    currentPage === totalPages || totalPages === 0
                                }
                            >
                                <PaginationLink
                                    onClick={() => setCurrentPage(dataInfo.totalPage)}
                                >
                                    หน้าสุดท้าย
                                </PaginationLink>
                            </PaginationItem>
                        </Pagination>
                    </Col>
                    {/* <Col lg={3}>จำนวนข้อมูลที่แสดง</Col>
                <Col lg={2}>
                  <Input
                    value={pageSize}
                    type="select"
                    onChange={(e) => setPageSize(e.target.value)}
                    placeholder="...กรุณาใส่คำที่ต้องการค้นหา"
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                  </Input>
                </Col> */}
                </Row>
                <Modal isOpen={openModal} toggle={() => toggleModal(undefined, undefined, undefined, undefined)} centered >
                    <ModalHeader toggle={() => toggleModal(undefined, undefined, undefined, undefined)}>
                        รายละเอียดครุภัณฑ์
                    </ModalHeader>
                    <ModalBody className="p-0">
                        <ListGroup>
                            <ListGroupItem>
                                <b> กลุ่ม : </b> {dataGroup}
                            </ListGroupItem>
                            <ListGroupItem>
                                <b> ประเภท : </b> {dataClassName}
                            </ListGroupItem>
                            <ListGroupItem>
                                <b> ชนิด : </b> {dataType}
                            </ListGroupItem>
                            {/* <ListGroupItem>
                     <b> รายละเอียดเพิ่มเติม : </b> {dataDetail}
                    </ListGroupItem> */}
                            <ListGroupItem>
                                <b> อายุการใช้งาน : </b> {dataLifetime} ปี
                            </ListGroupItem>
                        </ListGroup>
                    </ModalBody>
                </Modal>
                {/* </CardBody>
          </Card> */}
            </FadeIn>
        </div>
    );
};

export default Menu2;
